import Image from "next/image"
// import csatnewbatch from "../../assets/images/Delhi/csat-web-banner.jpg";
import upscresult from "../../assets/images/Delhi/UPSC-Result-Press-ad-2024-Web-Banner-Delhi.jpg";
import upscresult2024 from "../../assets/images/Delhi/UPSC-Result-2024-Mob-Banner-Delhi.jpg";
// import csatnewmob from "../../assets/images/Delhi/csat-mob-banner.jpg";
import upscbanner1 from "../../assets/images/home/Mob_Banner/Achivers-2026-Web-Banner.jpg";
import upscbanner2 from "../../assets/images/home/Mob_Banner/Banner.png";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp from "react-countup";
import NPFform from"../../components/NPFForm/npfform"
import Success from "../../assets/images/home/newicon/Success.jpg";
import Target1 from "../../assets/images/home/newicon/target.jpg";
import Faculty from "../../assets/images/home/newicon/Faculty.jpg";
import TestSeries from "../../assets/images/home/newicon/Testseries.jpg";
import Redrightarrow from  "../../assets/images/contact/Rarrow.png";
import downloadicon from "../../assets/images/download.png";
import upsc2702mobile from "../../assets/images/Delhi/Forestry-Optional-Delhi-Mobile-Banner.jpg";
import upsc2702web from "../../assets/images/Delhi/Forestry-Optional-Delhi-Web-Banner.jpg";
import sectionagriculture from "../../assets/images/Delhi/Forestry-Optional-Delhi--Web-Banner.jpg";
import upscadmissionb from "../../assets/images/Delhi/GS-HISTORY.jpg";
import prebookingb from "../../assets/images/Delhi/CSAT-Batch2.jpg";
import sctionmokash from "../../assets/images/Delhi/Moksha-2025-Banner.jpg";
import styles from "../upsc-admission-anna-nagar/upsc-ias-ips-admission.module.css";
import Carousel from 'react-bootstrap/Carousel';
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
const ObtionalButton = dynamic(()=>import("../../components/optionalbutton"));
const Interest = dynamic(() => import("../../components/might-be-interest"));
const Acheiver = dynamic(()=>import("../../components/our-acheiver/achievers"));
const BranchAddress = dynamic(() => import("../../components/branch-address"),{ ssr: false });
import Program_Features from "../upsc-admission-anna-nagar/upsc-ias-ips-admission-program-features";
import Classroom_form from "./delhi-form";
import Link from "next/link";
import useDownloader from "react-use-downloader";
import youtube_thumnail_1 from "../../assets/images/home/youtube/youtube_thumnail_33.webp";
import youtube_thumnail_2 from "../../assets/images/home/youtube/Youtube-thumbnail_312.jpg";
//import youtube_thumnail_3 from "../../assets/images/home/youtube/Civil-Sabha.png";
import youtube_thumnail_3 from "../../assets/images/home/youtube/Felicitation-programme-2024.jpg";
import Delhiimg from "../../assets/images/Delhi/Delhi-WebPage-Image.jpg";
import NewiconA from "../../assets/images/Delhi/touch.png";
import Newicon1 from "../../assets/images/header/modalnew.png";
import Emioption from "../../components/Service/emioption";
import sadhana from "../../assets/images/upsc/sadhanaL-2.png";
import Optionalplus from "../../components/Service/optionalplus";
import Stdtestimonial from "../../components/Delhi-Testimonial/Testimonial";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";
import Modal from 'react-bootstrap/Modal';
import Head from "next/head";
const UPSCClassroomOnline = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const { download } = useDownloader();

  const [play, setPlay] = useState(false);
  const [play1, setPlay1] = useState(false);
  const [play2, setPlay2] = useState(false);
  const [play3, setPlay3] = useState(false);
  

  const fileUrl = "/pdf/SIA-Brochure-2025-Delhi.pdf";
  const filename = "SIA-Brochure-2025-Delhi.pdf"

  const feestructure = [ 
    { date: "21.07.2025", cont: "Regular", cont1: "11:00 am to 01:30 pm" },
  // { date: "23.06.2025", cont: "Regular", cont1: "Will be update" },
   
  ]

  const feestructure2 = [
   
    { date: "18.08.2025", cont: "Regular", cont1: "11:00 am to 01:30 pm & 02:30 pm to 05:00 pm" },
  
  ]

  const feestructure3 = [
    {date:"14.07.2025",cont:"Regular",cont1:"LAW",cont2:"02:30 pm to 05:00 pm"},
    {date:"15.07.2025",cont:"Regular",cont1:"PSIR",cont2:"02:30 pm to 05:00 pm"},
    {date:"19.07.2025",cont:"Weekend",cont1:"Agriculture",cont2:"10:00 am to 02:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Geography",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"History",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Psychology",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Public Administration",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Mathematics",cont2:"09:00 am to 01:00 pm"},
    {date:"05.07.2025",cont:"Weekend",cont1:"Tamil",cont2:"09:00 am to 01:00 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"Economics",cont2:"05:30 pm to 08:00 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"Sociology",cont2:"05:00 pm to 07:30 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"English Literature",cont2:"02:30 pm to 05:00 pm"},
    {date:"07.07.2025",cont:"Regular",cont1:"Anthropolgy",cont2:"02:30 pm to 05:00 pm"},
  ]
  
  const banners = [
        { img: upscbanner1, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
        { img: upscbanner2, alt: "UPSC Anna Nagar", link: "/upsc-admission-anna-nagar"},
    
      ]

  const stats1 = [
      { value: 2900, suffix: "+", label: "IAS, IPS & IFS Selections", delay: 100 },
      { value: 202, label: "of 958 | UPSC CSE 2025", delay: 200 },
      { value: 9, label: "Govt Partnerships", delay: 300 },
    ];


  const jsonLd = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Best IAS Academy in Delhi | Shankar IAS Academy",
            "url": "https://www.shankariasacademy.com/delhi/",
            "Image":
            "https://www.shankariasacademy.com/_next/static/media/Result-2022-Web-Banner-2.96c6f4ff.webp",
            "description": "Shankar IAS Academy is the best IAS Academy in Delhi, offering top-notch UPSC training, experienced faculty, and a high success rate in civil services."
  }
 
 
 const router = useRouter();
 
 useEffect(() => {
   AOS.init({
     duration: 800,
     easing: "ease-in-out",
     once: true,
     offset: 100,
   });
 }, []);
 
 useEffect(() => {
   const handleRouteChange = () => {
     AOS.refresh();
   };
 
   router.events.on("routeChangeComplete", handleRouteChange);
 
   return () => {
     router.events.off("routeChangeComplete", handleRouteChange);
   };
 }, [router.events]);
 

  return (
    <>
      <Head>
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-2ST7ZJ1RE5"></script>
      <script>
      {
      `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-2ST7ZJ1RE5');
      `
      }
  </script>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
        <meta charset="UTF-8" /> 
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="robots" content="noodp,noydir" />
        <meta name="robots" content="noindex,nofollow" />
        <meta name="robots" content="noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
        <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
        <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
        <title>Best IAS Academy in Delhi, India</title>
        <meta name="title" content="Best IAS Academy in Delhi, India" />
        <meta name="description" content="Shankar IAS Academy is the best IAS Academy in Delhi, offering top-notch UPSC training, experienced faculty, and a high success rate in civil services." />
        <link rel="canonical" href="https://www.shankariasacademy.com/delhi/" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Best IAS Academy in Delhi, India" />
        <meta property="og:description" content="Shankar IAS Academy is the best IAS Academy in Delhi, offering top-notch UPSC training, experienced faculty, and a high success rate in civil services." />
        <meta property="og:url" content="https://www.shankariasacademy.com/delhi/" />
        <meta property="og:site_name" content="Shankar IAS Academy" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@shankarias" />
        {/* <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script> */}
      </Head>

<Navbar title="upsc" />

  <div className="container">
      <div className="row">
        <div className="col-md-6">
          <div data-aos="fade-right" className= {`${styles.cardBox} d-flex flex-wrap gap-3 p-4`}>
            <h1>UPSC Civil Services Admission Open - 2026</h1>

              <Link href="/upsc-admission-anna-nagar" className= {`${styles.branchBtn} `}>
                Anna Nagar
              </Link>

              <Link href="/adyar" className={`${styles.branchBtn}`}>
                Adyar
              </Link>

              <Link href="/delhi" className={`${styles.branchBtn} `}>
                Delhi
              </Link>

              <Link href="/bengaluru" className={`${styles.branchBtn} `}>
                Bengaluru
              </Link>

              <Link href="/coimbatore" className={`${styles.branchBtn} `}>
                Coimbatore
              </Link>

              <Link href="/hyderabad" className={`${styles.branchBtn} `}>
                Hyderabad
              </Link>

              <Link href="/thiruvananthapuram" className={`${styles.branchBtn} `}>
                Trivandrum
              </Link>

              <Link href="/trichy" className={`${styles.branchBtn} `}>
                Trichy
              </Link>

              <Link href="/salem" className={`${styles.branchBtn} `}>
                Salem
              </Link>

              <Link href="/madurai" className={`${styles.branchBtn} `}>
                Madurai
              </Link>

              <Link href="/upsc-online-class" className={`${styles.branchBtn} `}>
                Online Class
              </Link>

              <Link href="/upsc-admission-nri" className={`${styles.branchBtn} `}>           
                NRI
              </Link>
          </div>

          <div data-aos="fade-left" className={`${styles.bestbg1}`}>
            <div className="p-4">
              <h2 className="text-center"> Pre Booking Open Now</h2> 
              <p>GSPCM will start on 16th February 2026. For pre-booking, contact the number - <span style={{color:'#db1b0d' }}>9003190030</span> </p>
              <div className={`${styles.brochure} justify-content-center`}>
                <a href="https://www.shankariasacademy.com/pdf/UPSC-2026/Brochure-Chennai-Admission-2026.pdf" target="_blank" rel="noopener noreferrer">
                  <button className={`${styles.normalbutton1} btn btn-danger`}>
                    <Image src={downloadicon} alt="download icon" /> UPSC GSPCM 2026 (Brochure)
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-md-6 pt-3">
          <Carousel>
            {banners.map((e, index) =>
              <Carousel.Item key={index}>
                <Link href={e.link} rel="noreferrer">
                  <Image
                  className="carouselimage w-100 h-100"
                  src={e.img}
                  alt={e.alt}
                  title="Shankar IAS Academy"
                  /> 
                </Link>
              </Carousel.Item>
            )}
          </Carousel>
        </div>
      </div>
  </div>   

 <div className="container-fluid "  style={{
      background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
      opacity: "1",
    }}>
    <div className="container">
      <div className= "row mt-4 mb-2 ">
        <div className={`${styles.admincontent} col-12 col-md-6 pt-4 mt-4`}>
          <div className={styles.heroCard} data-aos="fade-right">
            <span className={styles.badge}>India's Trusted UPSC Coaching</span>
            <h1 className={styles.title}>
              Best IAS Coaching in India
              <span> Shankar IAS Academy Delhi</span>
            </h1>
            <p className={styles.description}>
              Shankar IAS Academy stands as a pioneer in UPSC coaching, earning the reputation of being the Best IAS Academy in India through its consistent <b>track record</b> of producing top-ranking civil servants.
            </p>
            {/* Stats */}
            <div className={styles.statsRow}>
              {stats1.map((item, index) => (
                <div
                  key={index}
                  className={styles.statCircle}
                  data-aos="zoom-in"
                  data-aos-delay={item.delay}
                >
                  <span className={styles.circleGlow}></span>
                  <h3>
                    <CountUp
                      end={item.value}
                      duration={6.5}
                      suffix={item.suffix || ""}
                    />
                  </h3>
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
            {/* Features */}
            <div className={`${styles.featureGrid} pt-3`}>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="400">
              <span><Image src={Success} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>  High Success Rate 
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="500">
                <span><Image src={Target1} width="46" height="4 6" alt="New_icon" className="img-fluid mx-2" /></span> Prelims & Mains Integrated Coaching
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="600">
                  <span><Image src={Faculty} width="46" height="46" alt="New_icon" className="img-fluid mx-2" /></span>Expert Faculty & Mentorship
              </div>

              <div className={styles.featureCard} data-aos="fade-up" data-aos-delay="700">
                <span><Image src={TestSeries} width="36" height="36" alt="New_icon" className="img-fluid mx-2" /></span>Advanced Test Series
              </div>

            </div>

            <div  className={`${styles.newachievernumber1} text-end pt-4 d-none d-md-block`} data-aos="fade-up" data-aos-delay="400">
              <Link href="#" className={`${styles.acheivermore}`} id=""  onclick="fbq('track', 'ButtonClick');">
                <span style={{ color: "rgb(66, 60, 60)", fontWeight:"bold", fontSize:"16px" }}>& More</span> <Image src={Redrightarrow} className={`${styles.logoimg} img-fluid`} alt="Chennai Icon" width={20} height={20} />
              </Link>
            </div>
          </div>
        </div>
        <div class="col-12  col-md-6 mt-4 mb-2">
          <p className={`${styles.contactheader} text-center`}>Enquiry</p>
          <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
          {/* <div class={`${styles.addmissionform} npf_wgts `} data-height="600px"   data-w="3f4274baec4df825dd72c5ff92d085ff"> </div>  */}
          <NPFform
            formId="3f4274baec4df825dd72c5ff92d085ff"
            height="600px"
            className="myForm"
          />
        </div>
      </div>
    </div>
  </div>

  <section className="container pb-4">
      <div className="pt-4">
        <div className="row">                            
            <div className="col-lg-6 col-12 mb-3  d-md-block"style={{ cursor: "pointer" }}  onClick={() => {setModalOpen(true); setVideoURL("https://www.youtube.com/embed/46cqqJNbk10"); }}>
                <Image 
                  src={upscadmissionb} 
                  width="579" height="253" className="img-fluid h-100 w-100" alt="UPSC Personality test 2025" 
                />
            </div>

            <div className="col-lg-6 col-12 mb-3  d-md-block">
              <a href="#preebooking" ><Image src={prebookingb} width="579" height="253" className="img-fluid h-100 w-100" alt="prebooking" /> </a>
            </div>
        </div>
        <div className="row">
          {/* <div className="col-lg-6 col-12 mb-3  d-md-block">
                <a href="/forestry-admission" target="_blank"> <Image src={sectionagriculture} width="579" height="253" className="img-fluid h-100 w-100" alt="agriculture" /></a>
              </div>
            
            <div className="col-lg-6 col-12 mb-3  d-md-block">
                <a href="https://www.shankariasacademy.com/upsc-mains-test-series/" target="_blank"><Image src={sctionmokash} width="579" height="253" className="img-fluid h-100 w-100" alt="agriculture" /></a>
              </div> */}
        </div>
      </div>
  </section>

  <section className={styles.sectionWrapper}>
    <div className="container">

      {/* ROW 1 */}
      <div className="row g-4">

        {/* UPSC Preparation */}
        <div className="col-lg-6">
          <div className={styles.infoCard}>
            <h3 className={styles.sectiontitle}>UPSC Preparation</h3>

            <p className={styles.delhiacheiver}>
              Every year around 10 lakh students apply for the UPSC examination. Among these only a few thousand students sail through the prelims and qualify for mains. Finally, only around 1000 candidates become a Civil Servant. The pass percentage of candidates in UPSC Civil Service examination is a meager 0.2%.
            </p>

            <p className={styles.delhiacheiver}>
            Joining the best IAS Academy, can save your precious time, as the content given will be refined to meet the demands of the UPSC. The Courses we offer in Shankar IAS Academy are performance-driven and Best IAS Coaching in Delhi
            </p>
          </div>
        </div>

        {/* Courses Offered */}
        <div data-aos="fade-down" className="col-lg-6">
          <div className={styles.infoCard}>
            <h3 className={styles.sectiontitle}>Courses Offered</h3>
            <p className={styles.delhiacheiver}>
              We offer a diverse array of courses, ranging from the GS Foundation Course for aspiring Civil Servants to Personality Test Coaching for seasoned aspirants on the cusp of their Civil Service journey. Our courses are scientifically designed and results-oriented, including:
            </p>

            <ul className={styles.courseList}>
              <li><b>General Studies</b> –  1 Year Foundation Course for Prelims and Mains</li>
              <li><b>General Studies</b> – 2 Years Foundation Course for Prelims and Mains <span style={{color:'#db1b0d'}}>(SADHANA)</span> </li>
              <li><b>Current Affairs Program</b>  – Classes + Exam  CHAKRA</li>
              <li><b>Optional Subject Courses</b></li>
              <li><b>Prelims Test Series</b> – Weekly <span style={{color:'#db1b0d'}}> (UPSC Prestorming ) </span> </li>
              <li><b>Prelims Test Series</b> – Daily <span style={{color:'#db1b0d'}}> (UPSC Prefit Test)</span> </li>
              <li><b>Mains Test Series</b> – <span style={{color:'#db1b0d'}}> MOKSHA </span> </li>
              <li><b>Indian Forest Service </b> - Mains Coaching</li>
              <li><b>Personality Test Coaching</b> - <span style={{color:'#db1b0d'}}>(CIVILIASATION)</span></li>
            </ul>
            <p className="text-center">For further details such as course schedules, durations, and fee structures, feel free to Contact us.</p>
          </div>
        </div>
      </div>

      <div data-aos="fade-down" className="row g-4 mt-2">
        <div className="col-lg-6">
          <div className={styles.infoCard}>
            <h3 className={styles.sectiontitle}>
              Why Choose Shankar IAS Academy in Delhi?
            </h3>

            <div className={styles.featureItem}>
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>In-depth UPSC syllabus coverage</span>
            </div>

            <div className={styles.featureItem}>
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Experienced Faculty Team</span>
            </div>

            <div className={styles.featureItem}>
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Frequent Interactions with Achievers</span>
            </div>

            <div className={styles.featureItem}>
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Personalized Mentoring</span>
            </div>

            <div className={styles.featureItem}>
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>AI-powered Test Series</span>
            </div> 

            <div className={styles.featureItem}>
              <i className="bi bi-check-circle-fill text-success"></i>
              <span>Interview Guidance</span>
            </div>
          </div>
        </div>

        {/* ACHIEVEMENTS */}
        <div data-aos="fade-down" className="col-lg-6">
          <div className={styles.infoCard}>
            <h3 className={styles.sectiontitle}>Achievements</h3>

            <div className="row text-center">

              <div className="col-12 col-md-4">
                <div className={styles.achievementBox}>
                  <h4>2700+</h4>
                  <p>Selections</p>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className={styles.achievementBox}>
                  <h4>25</h4>
                  <p>Top 100 (2024)</p>
                </div>
              </div>

              <div className="col-12 col-md-4">
                <div className={styles.achievementBox}>
                  <h4>238</h4>
                  <p>Selections 2024</p>
                </div>
              </div>

            </div>

          <div data-aos="fade-down" className="row">
            <div className="col-12 col-md-6">
              <ul className={styles.tickList}>
                <li className={styles.acheiverresult}>2024 - 238 Selections out of 1009 vacancies</li>
                <li className={styles.acheiverresult}>2023 - 273 Selections out of 1016 vacancies</li>
                <li className={styles.acheiverresult}>2022 - 336 Selections out of 1022 vacancies</li>
                <li className={styles.acheiverresult}>2021 - 260 Selections out of 712 vacancies</li>
                <li className={styles.acheiverresult}>2020 - 363 Selections out of 836 vacancies</li>
                <li className={styles.acheiverresult}>2019 - 201 Selections out of 927 vacancies</li>
              </ul>
            </div>

            <div className="col-12 col-md-6">
              <ul className={styles.tickList}>
                <li className={styles.acheiverresult}>2024 - 78 selections out of 143 vacancies</li>
                <li className={styles.acheiverresult}>2023 - 102 selections out of 147 vacancies</li>
                <li className={styles.acheiverresult}>2022 - 101 selections out of 147 vacancies</li>
                <li className={styles.acheiverresult}>2021 - 79 selections out of 108 vacancies</li>
                <li className={styles.acheiverresult}>2020 - 50 selections out of 90 vacancies</li>
                <li className={styles.acheiverresult}>2019 - 46 selections out of 88 vacancies</li>
              </ul>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </section>

   <div className={`${styles.sadhana} p-2`}>
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-6 text-white mt-2 p-2 ">UPSC GS-Mains Test Series 2025 (Moksha)<br />
            <a href="/upsc-mains-test-series/" className={`${styles.normalbutton} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}> Click here <span></span></a>
        </div>
        <div className="col-12 col-md-6 text-white mt-2 p-2 order-first order-md-last">UPSC GSPCM 2025 (Brochure)<br />
            <button className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`} onClick={() => download(fileUrl, filename)}>
              <p className=""> <Image src={downloadicon} alt="download icon" /> Download Brochure</p>
            </button>
        </div>
      </div>
    </div>
  </div>

  <section id="courseandfees">
    <div className="container py-5">
      <h2 className={`text-center mb-5 ${styles.mainTitle}`}>Course & Fee Structure – 2026</h2>
      <div className="row g-4">
        {/* = GS CARD = */}
        <div data-aos="fade-down" className="col-xl-4 col-lg-6 col-12">
          <div  className={`${styles.premiumCard} ${styles.highlightCard} h-100`}>
            <div className={styles.ribbon}>Admission Opening</div>
            <div className={styles.cardTop}>
              <h4>General Studies</h4>
              <p>Preliminary Cum Mains</p>
            </div>
            <div className={styles.priceBox}>
              ₹1,38,000
              <span>Inclusive of GST</span>
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* = CSAT CARD = */}
        <div data-aos="fade-up" className="col-xl-4 col-lg-6 col-12">
          <div className={`${styles.premiumCard} h-100`}>
            <div className={styles.cardTop}>
              <h4>CSAT</h4>
            </div>
            <div className={styles.priceBox}>
              ₹12,000
              <span>Inclusive of GST</span>
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure2.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont1}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* === OPTIONAL CARD === */}
        <div data-aos="fade-down" className="col-xl-4 col-lg-6 col-12">
          <div className={styles.premiumCard}>
            <div className={styles.cardTop}>
              <h4>Optional Subjects</h4>
            </div>

            <div className={styles.priceBox}>
              ₹34,000
            </div>
            <button className={styles.primaryBtn}>Pay Now</button>
            <div className={styles.scheduleSection}>
              {feestructure3.map((item, index) => (
                <div key={index} className={styles.scheduleItem}>
                  <div>{item.cont1}</div>
                  <div>{item.date}</div>
                  <div>{item.cont}</div>
                  <div>{item.cont2}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="col-xl-3 offset-xl-8 col-lg-4 col-md-6 col-8  text-end pb-2 ">
            <ObtionalButton />
        </div>
        
        <div data-aos="zoom-in" className={styles.premiumCard}>
          <div className={`${styles.facultyborder3} row h-100 `}>
            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <p className={`${styles.sectionsubtitle} mb-0`}>GSPCM+CSAT+Optional</p>
              <p className={`${styles.sectionsubtitle} pb-0`}>Total Amount</p>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12">
              <span className={`${styles.acheiverrank}`}> <span className={`${styles.sectionredtitle} `}><b>₹</b>1,84,000*</span><span>(inclusive of tax)</span></span>
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right">
              <Emioption />                
            </div>

            <div className="col-xl-3 col-lg-4 col-md-6 col-12  text-right pt-xl-0 pt-3">
              <a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=UPSC" target="_blank" rel="noreferrer" className={`${styles.viewbuttonalink}`}><button type="button" className={`${styles.normalbutton}`}>Pay Here</button></a>
            </div>

            <p className={`${styles.aboutparagraph1}  p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;Fees are inclusive of GST & SIA study materials.</p>
          </div>
        </div>

        <div className="row">
          <div  className="col-md-12 col-lg-8 col-xl-8 col-12 pt-3 pe-xl-0">
            {/* <p className={`${styles.aboutparagraph1} p-2`}> <span className={`${styles.dot} pe-2`}>*</span>&nbsp;<b>₹5,000</b> Discount will be applicable for Integrated Course payment <b>(GS + CSAT + Optional)</b></p> */}
          </div>
          <div className="col-md-12 col-lg-6 col-xl-4 col-12 pt-3 ps-xl-0">
          </div>
        </div>
      </div>
    </div>
  </section>

  <div className="container">
      <Modal
        show={modalOpen}
        onHide={() => {
          setModalOpen(false);
          setVideoURL("");
        }}
        centered
        size="lg"
      >
      
        <div className="modal-header">
          <h5 className="modal-title">Course Preview 🎥</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => {
              setModalOpen(false);
              setVideoURL(""); // stop video
            }}
          ></button>
        </div>

        <Modal.Body className="p-0">
          <iframe
            width="100%"
            height="420"
            src={videoURL}
            title="CSAT Course Preview"
            frameBorder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            className="rounded-bottom-3"
          ></iframe>

        </Modal.Body>
      </Modal>

      {/* <div className={`${styles.facultyborder3} row p-4 h-100 mb-md-3`}>
        <div className="col-12 mt-2 p-2 d-flex flex-column align-items-center">
            <h4 className="fw-bold">UPSC Prelims Test Series 2026 </h4>
            <button
              className={`${styles.normalbutton2} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-3`}
              onClick={() => download(fileUrl, filename)}
            >
              Download Brochure
            </button>
        </div>
      </div> */}

      {/* <div className="container">
        <div className="py-4">
          <div className="row">
              <div className="col-lg-5 offset-lg-1 col-12 "> 
                  <div className={`${styles.founderbg} text-center`}></div> 
              </div>

              <div className="col-lg-6 col-12"> 
                  <h2 className={`${styles.foundertitle} mb-0`}>Mr . SHANKAR DEVARAJAN <br/></h2>
                  <p className={`${styles.foundertitle1} `}>(Founder)</p>
                  <p className={`${styles.sectiontitle}`} id={styles.aboucontentborder}>
                    Vision
                  </p>
                  <p className={`${styles.acheiverranks} `}>
                    To become a renowned institution producing eminent and
                    responsible civil servants for the society. To give hope and
                    opportunity to aspirants from various social-economic
                    backgrounds to realize their dream of becoming civil servants.
                  </p>

                  <p className={`${styles.sectiontitle} pt-0`} id={styles.aboucontentborder}>
                    Mission
                  </p>

                  <p className={`${styles.acheiverranks} `}>
                    To provide meticulous and focused training to the aspirants to
                    succeed in the Civil Services examination.
                  </p>
                  <p className={`${styles.acheiverranks} `}>
                    To create an environment where the students have access to all
                    that is required to prepare for the civil services examination
                    effectively, efficiently and enthusiastically by ensuring them
                    with excellent coaching and finest study materials.
                  </p>

              </div>
          </div>    

          <div className="row">
              <div className="col-lg-6 col-12"> 
                  <h2 className={`${styles.foundertitle} mb-0`}>Dr.S.D.Vaishnavi<br/></h2>
                  <p className={`${styles.foundertitle1} `}>(Director)</p>
                  <p className={`${styles.acheiverranks} `}>
                    Behind every successful individual, there is often a strong support system, and in the case of this institute and its founder, Dr. Vaishnavi S. D. plays a pivotal role. As both an academician and co-founder, her contributions have been essential to the institute's incredible journey. With a PhD in Health Economics from IIT Madras and a background from TNAU, she is a sought-after columnist in leading economics publications. 
                  </p>
                <p className={`${styles.acheiverranks} `}>
                For students from non-economics backgrounds, who often find it challenging to grasp fundamental concepts, her classes provide clear insights and a deep understanding of core topics. Dr. Vaishnavi embodies the qualities of a well-educated and poised individual, whose optimism and grace inspire those around her. She will also be instrumental in shaping the future of UPSC aspirants.
                </p>
              </div>

              <div className="offset-lg-2 col-lg-4  col-12 pt-4"> 
                    <div className={`${styles.founderbg1} text-center`}></div> 
              </div>
          </div>

          <div className="row pt-4">
            <div className="offset-lg-1 col-lg-5  col-12 pt-4"> 
              <div className={`${styles.founderbg2} text-center`}></div> 
            </div>
            <div className="col-lg-6 col-12"> 
                <h2 className={`${styles.foundertitle} pt-4`}>Dr.S.R.Deenadayalan<br/></h2>
                <p className={`${styles.foundertitle1} `}>(Managing Partner )</p>
                <p className={`${styles.acheiverranks} `}>
                Mr.S.R.Deenadayalan father of Mrs.Vaishnavi has been actively participating as managing partner of shankar IAS Academy for the past 10 years. He has vast experience in managing the bookstore of the academy called Bookmark. His knowledge and guidance had been a great help for shaping up the administration of the academy.
              </p>
            </div> 
          </div>
        </div>
      </div> */}
  </div>

 

  <div className="container py-4">
    <h5 className={`text-center ${styles.bangmainTitle}`}>Program Features & Benefits</h5>
    <Program_Features />
  </div>

    {/* Our Acheivers */}

  <div className="container">
    <div className="row">
      <div className="col pt-4 pt-md-5 text-center">
        <h2 className={`${styles.sectiontitle} mb-0`}>Our Achievers</h2>
        <p className={`${styles.sectionsubtitle}`}>
          Rank Holders from our academy
        </p>
      </div>
    </div>
  </div>

  <Acheiver />

<section className=""  style={{
      background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",
      opacity: "1",
    }} >  
  <div className="container pt-2">
    <Stdtestimonial/>
  </div>
</section>

  <section id="toppers">
    <div className="container">
      <div className="row">
        <div className="  col-xl-12 col-lg-6 mb-3 mb-md-4 col-12 ">
          <Optionalplus /> 
        </div>
      </div>
    </div>
  </section>

  <section className={`${styles.bground}`}>  
      <div className="row">
        <div className="col text-center">
          <h2 className={`${styles.sectiontitle} mb-0 text-center`}>Testimonials</h2>
          <p className={`${styles.sectionsubtitle} text-center`}>
            Hear it from our Achievers
          </p>
        </div>
      </div> 

      <div className="container mb-2 mb-xl-5">
        <div className="row">
          <div className="col-12 col-lg-6 my-md-3 px-xl-3">
            {
              play2 ?
                (<iframe src={"https://www.youtube.com/embed/Xwj4MXW1REw?si=XzLmpvMcARGUq-Bu" } className="w-100 h-100  mb-md-3" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
                    :
                (<Image src={youtube_thumnail_3} style={{ cursor: 'pointer' }} onClick={() => setPlay2(true)} className="img-fluid h-100 w-100  mb-md-3"
                      id="homeyoutube" alt="youtube thumbnail"></Image>)
                }
                <div className="d-none d-md-block">
                      <Link
                      href="https://www.iasparliament.com/UPSC-IAS-daily-current-videos"
                      target="_blank"
                      className={`${styles.acheiverrank, styles.courseknowmore} float-end`}
                    >
                    </Link>
                </div>
          </div>
          <div className="col-12 col-lg-6 pt-3 pt-md-0 my-md-3 px-xl-3">
            {
              play3 ?
                (<iframe src={"https://www.youtube.com/embed/QEouXid_hQ0?si=VoLJhB32F87KdH60"} className="w-100 h-100" id="homeyoutube" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen style={{ borderWidth: '0' }}></iframe>)
                    :
                (<Image src={youtube_thumnail_2} style={{ cursor: 'pointer' }} onClick={() => setPlay3(true)} className="img-fluid h-100 w-100"
                  id="homeyoutube" alt="youtube thumbnail"></Image>)
              }
          </div>
        </div>
      </div>
  </section>

  <BranchAddress />
  <Interest />
  <Footer />

    </>
  )
}

export default UPSCClassroomOnline;
